import { API } from "../../legacy/api";

export type ErrorHandler = "error";

export const showError = (error: string, origin?: string) => {
  const message = origin ? `[${origin}] ${error}` : error;
  API.notify("error", {
    message: error,
    event: origin || "unknown"
  });

  console.error(message);
};
